import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { formatCommissionAmount, maskReferredUserId } from "@/lib/affiliateDashboard";
import type { PayoutBatchRow } from "./types";

type Props = {
  batches: PayoutBatchRow[];
  batchesLoading: boolean;
};

export const RecentBatchesTable = ({ batches, batchesLoading }: Props) => (
  <Card className="shadow-soft">
    <CardHeader>
      <CardTitle>Recent payout batches</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="overflow-x-auto rounded-md border border-border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Paid</TableHead>
              <TableHead>Affiliate</TableHead>
              <TableHead className="text-right">Amount</TableHead>
              <TableHead className="text-right">Items</TableHead>
              <TableHead>Reference</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {batchesLoading ? (
              <TableRow>
                <TableCell colSpan={5}>
                  <Skeleton className="h-8 w-full" />
                </TableCell>
              </TableRow>
            ) : batches.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} className="text-center text-muted-foreground">
                  No payout batches yet.
                </TableCell>
              </TableRow>
            ) : (
              batches.map((b) => (
                <TableRow key={b.id}>
                  <TableCell className="whitespace-nowrap text-xs">
                    {new Date(b.paid_at).toLocaleDateString()}
                  </TableCell>
                  <TableCell className="font-mono text-xs">
                    {maskReferredUserId(b.affiliate_user_id)}
                  </TableCell>
                  <TableCell className="text-right font-medium">
                    {formatCommissionAmount(b.total_amount_cents, b.currency)}
                  </TableCell>
                  <TableCell className="text-right">{b.commission_count}</TableCell>
                  <TableCell className="text-xs text-muted-foreground">
                    {b.payment_reference ?? "—"}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>
    </CardContent>
  </Card>
);
